"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _FoldersAndFiles = _interopRequireDefault(require("FileManagerLib/components/browser/FoldersAndFiles"));

var _Files = require("FileManagerLib/actions/Files");

var _Actions = require("FileManagerLib/actions/Actions");

var _Constants = require("FileManagerLib/Constants");

var _UploadingFiles = require("FileManagerCore/selectors/UploadingFiles");

var _Panel = require("FileManagerLib/selectors/Panel");

var mapStateToProps = function mapStateToProps(state) {
  return {
    selectedFolder: (0, _Panel.getSelectedFolderInPanel)(state),
    selectedFile: (0, _Panel.getSelectedFileInPanel)(state),
    uploadingFiles: (0, _UploadingFiles.getUploadingFiles)(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSelectFolder: function onSelectFolder(folder) {
      dispatch((0, _Actions.setPanel)({
        activePanel: _Constants.Panels.FOLDER,
        selectedFolder: folder
      }));
    },
    onSelectFile: function onSelectFile(file, meta) {
      dispatch(file ? (0, _Actions.selectFile)(file, meta) : (0, _Actions.deselectFile)(meta));
    },
    onDropFiles: function onDropFiles(files, folder, type) {
      var options = {
        folderId: folder.get('id'),
        type: type
      };
      dispatch((0, _Files.uploadFiles)(files, options));
      dispatch((0, _Actions.setPanel)({
        activePanel: _Constants.Panels.FOLDER,
        selectedFolder: folder
      }));
      dispatch((0, _Actions.trackInteraction)('Manage Files', 'drag-and-dropped-file'));
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_FoldersAndFiles.default);

exports.default = _default;
module.exports = exports.default;